var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-0 m-0",staticStyle:{"position":"relative"}},[_c('canvas',{staticStyle:{"position":"absolute","pointer-events":"none","left":"0","top":"0"},attrs:{"id":"overlay","width":_vm.size.width,"height":_vm.size.height}}),_c('canvas',{attrs:{"id":"chart","width":_vm.size.width,"height":_vm.size.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }